import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";
import type {Snapshot} from "./ModelTypes.ts";

export class SnapshotAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = localization;
    }
}

export const snapshot = {
    snapshots: [] as Snapshot[],

    async getSnapshotList() {
        try {
            const snapshot = await restfulApiClient.get("snapshot", 1)
            if (snapshot) {
                this.snapshots = snapshot.data.data;
            }
            return this.snapshots;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SnapshotAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async create(instance_id: number, name: string) {
        const payload = {
            "name": name,
            "server_id": instance_id,
        };
        try {
            return await restfulApiClient.post(`snapshot/${instance_id}`, 1, payload);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SnapshotAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async modify_name(image_id: number, name: string) {
        const payload = {
            "name": name,
        }
        try {
            return await restfulApiClient.patch(`snapshot/${image_id}`, 1, payload);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SnapshotAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async delete(image_id: number) {
        try {
            return await restfulApiClient.delete(`snapshot/${image_id}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SnapshotAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },
}